export const getMinimumStays = ({
  minimumStays = [],
  selectedRatePlanId,
  value,
}) => {
  let results = [];
  // if minimumStays is not a non-empty array, assign a new array with the item
  if (!Array.isArray(minimumStays) || minimumStays.length === 0) {
    results = [{ ratePlanId: selectedRatePlanId, minStay: value }];
  } else {
    // find if the rate plan already exists
    const index = minimumStays.findIndex(
      (item) => item.ratePlanId === selectedRatePlanId
    );

    // if not found, append the new item by assigning to minimumStays
    if (index === -1) {
      results = [
        ...minimumStays,
        { ratePlanId: selectedRatePlanId, minStay: value },
      ];
    } else {
      results = [...minimumStays];
    }
    // otherwise update the matching item and keep others by assigning the mapped array
    results = results.map((item) =>
      item.ratePlanId === selectedRatePlanId
        ? { ...item, minStay: value }
        : item
    );
  }

  return results;
};
